import { render, staticRenderFns } from "./SendEmailConfig.vue?vue&type=template&id=7dd81c80&scoped=true"
import script from "./SendEmailConfig.vue?vue&type=script&lang=js"
export * from "./SendEmailConfig.vue?vue&type=script&lang=js"
import style0 from "./SendEmailConfig.vue?vue&type=style&index=0&id=7dd81c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd81c80",
  null
  
)

export default component.exports